if (!Array.prototype.at) {
  Array.prototype.at = function <T>(this: T[], index: number): T | undefined {
    if (index < 0) {
      index = this.length + index;
    }
    if (index < 0 || index >= this.length) {
      return undefined;
    }
    return this[index];
  };
}
